import { render } from "./TeamResultIntermiadiateBlock.vue?vue&type=template&id=2271c2fb&scoped=true&ts=true"
import script from "./TeamResultIntermiadiateBlock.vue?vue&type=script&lang=ts"
export * from "./TeamResultIntermiadiateBlock.vue?vue&type=script&lang=ts"

import "./TeamResultIntermiadiateBlock.vue?vue&type=style&index=0&id=2271c2fb&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2271c2fb"]])

export default __exports__